export const EmergencyBandFields = {
  message: {
    type: "text",
    label: "Message",
    metadata: {
      source: "manual",
      description:
        "The line shown beside the call button. Whether the band appears at all comes from the emergency service toggle in Business settings, not from here.",
    },
  },
} as const;
